import React from 'react';

import { SearchOutlined } from '@ant-design/icons';

import IconFilter from '../IconFilter';

interface ListViewProps {
    icon?: any;
    name: string;
    checkeds?: any[];
    savedSearch?: string;
    color?: string;
}

// Обрезает текст до maxLength символов
const truncateText = (text: string, maxLength: number): string => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '…';
};

const ListView = ({ icon, name, checkeds = [], savedSearch, color }: ListViewProps) => {
    const safeCheckeds = Array.isArray(checkeds) ? checkeds : [];
    
    // Определяем сколько значений показывать (1-2) в зависимости от длины
    const totalLength = safeCheckeds.reduce((acc, item) => acc + (item.name?.length || 0), 0);
    const maxVisible = totalLength > 120 ? 1 : 2;
    const maxItemLength = maxVisible === 1 ? 80 : 60;
    
    const start = safeCheckeds.slice(0, maxVisible);
    const end = safeCheckeds.slice(maxVisible);

    return (
        <>
            <IconFilter icon={icon} />
            &nbsp;
            {name.replace(/&nbsp;/g, ' ')}:&nbsp;

            {/* Показываем сохранённый поиск если есть */}
            {savedSearch && (
                <>
                    <span 
                        style={{ 
                            backgroundColor: '#ffffff',
                            color: color || '#d4a024',
                            padding: '2px 8px',
                            borderRadius: 12,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4,
                            fontSize: 12,
                            fontWeight: 500,
                        }}
                        title="Сохранённый поиск"
                    >
                        <SearchOutlined style={{ fontSize: 11 }} />
                        {truncateText(savedSearch, 50)}
                    </span>
                    {safeCheckeds.length > 0 && <span style={{ opacity: 0.7 }}> → </span>}
                </>
            )}

            {/* Показываем выбранные значения */}
            {start.map((item: any, index: number) => {
                const itemName = item.name?.replace(/&nbsp;/g, ' ') || '';
                return (
                    <span key={item.id} title={itemName}>
                        {index > 0 && <span style={{ opacity: 0.5 }}> или </span>}
                        {truncateText(itemName, maxItemLength)}
                    </span>
                );
            })}

            {end.length > 0 && <span style={{ opacity: 0.5 }}> +{end.length}</span>}

            {/* Если нет значений и нет сохранённого поиска */}
            {safeCheckeds.length === 0 && !savedSearch && (
                <span style={{ opacity: 0.5, fontStyle: 'italic' }}>нет значений</span>
            )}
        </>
    );
};

export default ListView;
